<!-- 月销售报表 -->
<template>
  <div id="home">
    <van-nav-bar
      :title="$route.query.year + '-' + $route.query.month"
      left-arrow
      fixed
      :right-text="$t('DayReport.export')"
      @click-left="$router.go(-1)"
      @click-right="onClickExport"
    >
    </van-nav-bar>
    <van-cell-group>
      <van-cell>
        <van-row>
          <!-- <van-col span="6">{{$t('MonthDetail.date')}}</van-col>
					<van-col span="12">{{$t('MonthDetail.peoopleNum')}}</van-col>
					<van-col span="6">{{$t('MonthDetail.price')}}({{currency}})</van-col> -->
          <van-col span="2">{{ $t("MonthDetail.date") }}</van-col>
          <van-col span="2">{{ $t("MonthDetail.peoopleNum") }}</van-col>
          <van-col span="4">Line Pay</van-col>
          <van-col span="4">{{ $t("payMethod.card") }}</van-col>
          <van-col span="4">{{ $t("payMethod.cash") }}</van-col>
          <van-col span="4">{{ $t("payMethod.other") }}</van-col>
          <van-col span="4"
            >{{ $t("payMethod.totalprice") }} ({{ currency }})</van-col
          >
        </van-row>
        <div slot="right-icon" style="width: 22px;"></div>
      </van-cell>
      <template v-for="(item, index) in monthData">
        <van-cell
          is-link
          :to="{
            path: '/DayReport',
            query: {
              year: $route.query.year,
              month: $route.query.month,
              day: item.day
            }
          }"
        >
          <van-row>
            <van-col span="2">{{ item.day }}</van-col>
            <van-col span="2">{{ item.number }}</van-col>
            <van-col span="4">{{ item.line_pay }}</van-col>
            <van-col span="4">{{ item.card }}</van-col>
            <van-col span="4">{{ item.price }}</van-col>
            <van-col span="4">{{ item.other }}</van-col>
            <van-col span="4">{{ item.total }}</van-col>
          </van-row>
        </van-cell>
      </template>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      monthData: [],
      currency: ""
    };
  },
  mounted: function() {
    this.getMonthData();
    this.getCurrency();
    sessionStorage.setItem("year", JSON.stringify(this.$route.query.year));
  },
  methods: {
    // 获取月报表
    getMonthData() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/store/" +
          sessionStorage.actShopId +
          "/eachMonthIncome",
        data: {
          year: this.$route.query.year,
          month: this.$route.query.month
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.monthData = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {});
    },
    // 获取店铺设置的货币
    getCurrency() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build + "/api/store/" + sessionStorage.actShopId + "/currency"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.currency = res.data.data.unit;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 导出报表
    onClickExport() {
      window.location.href =
        this.$build +
        "/api/store/" +
        sessionStorage.actShopId +
        "/exportReport?param=eachMonthIncome&year=" +
        this.$route.query.year +
        "&month=" +
        this.$route.query.month;
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 22px;
}
/deep/ .van-cell-group {
  padding-top: 46px;
}
/deep/ .van-nav-bar__right .van-nav-bar__text {
  color: #fff;
}
.chartBox {
  width: 100%;
  min-height: 240px;
  background-color: #fff;
}
.content {
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/Report/MonthDetail.vue